import {createApp} from "vue";
import styleText from './social-widget.css?inline';
import SocialWidget from "@/SocialWidget/Widget/SocialWidget.vue";
import Maska from 'maska'

customElements.define('dg-social-widget', class extends HTMLElement {
    // noinspection JSUnusedGlobalSymbols
    async connectedCallback(): Promise<void> {
        let shadow: ShadowRoot | undefined;
        let container: Element | undefined;

        if (process.env.NODE_ENV === "production") {
            shadow = this.attachShadow({mode: "open"});
            container = shadow.appendChild(document.createElement('div'));
        } else {
            container = this;
        }

        createApp(SocialWidget, {
            'widgetId': this.getAttribute('widget-id'),
            'endpoint': this.getAttribute('endpoint'),
        }).use(Maska).mount(container);

        if (shadow) {
            this.addStyles(shadow);
        }
    }

    private addStyles(shadowRoot: ShadowRoot) {
        const sheet = new CSSStyleSheet();
        sheet.replaceSync(styleText);
        shadowRoot.adoptedStyleSheets = [sheet];

        Array.from(document.styleSheets)
            .filter(x => x.href?.includes('SocialWidget'))
            .forEach(x => {
                const sheet = new CSSStyleSheet();
                const css = Array.from(x.cssRules).map(rule => rule.cssText).join(' ');
                sheet.replaceSync(css);
                shadowRoot.adoptedStyleSheets.push(sheet);
            });
    }
});
